import { getActiveReports } from 'utils/helperMethods';
import MandateList from '../models/mandateList';
import {
    DOWNLOAD_MANDATE_REPORT_ERROR,
    DOWNLOAD_MANDATE_REPORT_SUCCESS,
    FETCH_MANDATES_LIST_ERROR,
    FETCH_MANDATES_LIST_REQUEST,
    FETCH_MANDATES_LIST_SUCCESS,
    FETCH_MANDATE_TRANSACTION_LIST_ERROR,
    FETCH_MANDATE_TRANSACTION_LIST_REQUEST,
    FETCH_MANDATE_TRANSACTION_LIST_SUCCESS,
    GENERATE_MANDATE_REPORT_ERROR,
    GENERATE_MANDATE_REPORT_REQUEST,
    GENERATE_MANDATE_REPORT_SUCCESS,
    GET_ACTIVE_MANDATE_REPORT_ERROR,
    GET_ACTIVE_MANDATE_REPORT_SUCCESS,
    HIDE_MANDATE_LOADER,
    RESET_MANDATE_TRANSACTION_LIST_DATA,
    SHOW_MANDATE_LOADER,
    UPDATE_MANDATE_STATUS_REQUEST,
    UPDATE_MANDATE_STATUS_SUCCESS,
} from './mandates.constant';

const initialState = {
    tableData: [],
    pagination: {},
    error: {},
    statusData: {
        details: {},
        error: {},
    },
    mandateTransactionData: {
        details: [],
        error: {},
        hasNextPage: true,
        isUpdating: false,
        isLoading: false,
    },
    generatedFile: {
        isSuccess: false,
        error: {},
    },
    activeReports: {
        reports: {},
        error: {},
    },
    downloadReport: {},
    isLoading: false,
};

export const mandatesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MANDATES_LIST_SUCCESS: {
            const createTransactionData = new MandateList(action.payload);
            return {
                ...state,
                ...createTransactionData,
                error: {},
            };
        }
        case FETCH_MANDATES_LIST_REQUEST:
            return {
                ...state,
                error: {},
            };
        case FETCH_MANDATES_LIST_ERROR:
            return {
                ...state,
                tableData: [],
                ...action.payload,
            };
        case FETCH_MANDATE_TRANSACTION_LIST_REQUEST: {
            const { mandateTransactionData } = state;
            mandateTransactionData.isLoading = true;
            return {
                ...state,
                mandateTransactionData: {
                    ...mandateTransactionData,
                },
            };
        }
        case FETCH_MANDATE_TRANSACTION_LIST_SUCCESS: {
            const { mandateTransactionData } = state;

            const { details } = mandateTransactionData;
            return {
                ...state,
                mandateTransactionData: {
                    details: [
                        ...details,
                        ...action.payload.mandateTxnResponseList,
                    ],
                    error: {},
                    hasNextPage: action.payload.hasNext,
                    isLoading: false,
                },
            };
        }
        case FETCH_MANDATE_TRANSACTION_LIST_ERROR:
            return {
                ...state,
                mandateTransactionData: {
                    details: [],
                    error: action.payload.error,
                    isLoading: false
                },
            };
        case UPDATE_MANDATE_STATUS_REQUEST: {
            const { mandateTransactionData } = state;
            mandateTransactionData.isUpdating = true;
            return {
                ...state,
                mandateTransactionData: {
                    ...mandateTransactionData,
                },
            };
        }
        case UPDATE_MANDATE_STATUS_SUCCESS: {
            const { mandateTransactionData } = state;
            mandateTransactionData.isUpdating = false;
            return {
                ...state,
                mandateTransactionData: {
                    ...mandateTransactionData,
                },
            };
        }
        case RESET_MANDATE_TRANSACTION_LIST_DATA: {
            return {
                ...state,
                mandateTransactionData: initialState.mandateTransactionData,
            };
        }
        case DOWNLOAD_MANDATE_REPORT_SUCCESS:
            return {
                ...state,
                downloadReport: { fileUrl: { ...action.payload } },
            };
        case DOWNLOAD_MANDATE_REPORT_ERROR:
            return {
                ...state,
                downloadReport: { ...action.payload },
            };
        case GENERATE_MANDATE_REPORT_REQUEST:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case GENERATE_MANDATE_REPORT_SUCCESS:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: true },
            };
        case GENERATE_MANDATE_REPORT_ERROR:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case GET_ACTIVE_MANDATE_REPORT_SUCCESS:
            return {
                ...state,
                activeReports: { reports: getActiveReports(action.payload) },
            };
        case GET_ACTIVE_MANDATE_REPORT_ERROR:
            return {
                ...state,
                activeReports: { ...action.payload },
            };

        case SHOW_MANDATE_LOADER:
            return { ...state, isLoading: true };
        case HIDE_MANDATE_LOADER:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};
